import { render, staticRenderFns } from "./DefaultLocationsSearch.vue?vue&type=template&id=6c9a870f&scoped=true&"
import script from "./DefaultLocationsSearch.vue?vue&type=script&lang=js&"
export * from "./DefaultLocationsSearch.vue?vue&type=script&lang=js&"
import style0 from "./DefaultLocationsSearch.vue?vue&type=style&index=0&id=6c9a870f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9a870f",
  null
  
)

export default component.exports